import React from 'react';
import Home from './pages/Home';

function App() {
  return (
    <div className='app-container'>
      <Home />
    </div>
  );
}

export default App;
